// extracted by mini-css-extract-plugin
module.exports = {"link":"DropdownItem_link__jw1lv","active":"DropdownItem_active__Lb1f5","withMobileDisplay":"DropdownItem_withMobileDisplay__N6C15","item":"DropdownItem_item__hYfKM"};